import VerificationFailScene from './VerificationFailScene'
export default VerificationFailScene